import { type FC } from 'react';
import { HiCheckCircle } from 'react-icons/hi2';

import cn from '@core/utils/classNames';

import styles from './LearnMoreHeaderAndSubheader.module.css';

type Props = {
  biggerFontAndSpacing?: boolean;
  noPii?: boolean;
};

const LearnMoreHeaderAndSubheader: FC<Props> = ({ biggerFontAndSpacing, noPii }) => (
  <section className={styles.learnMoreConversionCtaTest}>
    <span className={styles.learnMoreConversionCtaTestHeader}>
      {!noPii && <HiCheckCircle size={32} />}
      <h1>Want to learn more?</h1>
    </span>
    <p className={cn(styles.learnMoreConversionCtaTestContent, biggerFontAndSpacing && styles.biggerFontAndSpacing)}>
      {!noPii
        ? "Submit your contact information to show this school you're interested! You can even start your application on the next screen."
        : "Enter your details to start a conversation with a school advisor. Once you submit, you'll be able to start your application."}
    </p>
  </section>
);

export default LearnMoreHeaderAndSubheader;
